import React, { useState, useEffect, useMemo } from "react";
import { API } from "../../API";
import AdminWrapper from "./AdminWrapper"
import SwitchMenuBar from "../../Components/SwitchMenuBar/SwitchMenuBar";
import ReactTable from "react-table-6";
import moment from "moment";
import { Link } from "react-router-dom";
import { getTeacherFullName, getTeacherState, PAY_LEVEL_STATUS, showPayLevelStatus } from "../../Helper";
import Pagination from '@mui/material/Pagination';
import FormDropdown from "../../Components/FormField/FormDropdown";
import debounce from 'lodash/debounce';
import teacherRateImg from "../../assets/img/teacherRate.jpeg";

const BuildFilterTeacher = (props) => {
  const { initialFilter, submitFilter, setGlobalFilter, exportFilter } = props
	const [filterOption, setFilterOption] = useState(initialFilter)
  const onChangeValue = debounce((key, value) => {
		const newValue = {
			...filterOption,
			[key]: value
		}
		setFilterOption(newValue)
    setGlobalFilter(newValue)
	}, 0);

  return (
		<div id="accordion">
			<div class="card w-100">
				<div class="card-header border-none" id="headingOne">
					<h5 class="mb-0 d-flex justify-content-between">
            <div></div>

						<div className="d-flex justify-content-end">
              <button class="btn btn-info" onClick={() => submitFilter(filterOption)} disabled={props.disabled}>
                Apply
              </button>
              {/* <button class="btn btn-info" onClick={() => exportFilter(filterOption)} disabled={props.onExport}>
                Export Filter
              </button> */}
            </div>
					</h5>
				</div>

				<div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
					<div class="card-body">
						<div className="d-flex flex-column">
							<div className="d-flex flex-row">
								<div className="mx-2 flex-fill">
									<p>First Name</p>
									<input
										onChange={event => onChangeValue("firstName", event.target.value)}
										value={filterOption?.firstName ? filterOption?.firstName : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
                <div className="mx-2 flex-fill">
									<p>Last Name</p>
									<input
										onChange={event => onChangeValue("lastName", event.target.value)}
										value={filterOption?.lastName ? filterOption?.lastName : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
                <div className="mx-2 flex-fill">
									<p>Preferred Name</p>
									<input
										onChange={event => onChangeValue("preferredName", event.target.value)}
										value={filterOption?.preferredName ? filterOption?.preferredName : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
								<div className="mx-2 flex-fill">
									<p>Email</p>
									<input
										onChange={event => onChangeValue("email", event.target.value)}
										value={filterOption?.email ? filterOption?.email : ''}
										className="my-2 form-control no-shadow"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

const TeacherPayLevel = (props) => {
    const [allUsers, setAllUsers] = useState([]);
    const [pageCount, setPageCount] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [loading, setLoading] = useState(false);
    const history = props.history

    const filterInSession = window.sessionStorage.getItem("allTeacherPayLevelFilter")
    const preFilter = filterInSession ? JSON.parse(filterInSession) : null
    let initialFilter = preFilter || {
      firstName: null,
      preferredName: null,
      email: null,
      lastName: null,
      state: null,
      isSearchable: null,
      isInXero: null,
      teacherType: null
    }
  
    const [globalFilter, setGlobalFilter] = useState(initialFilter)
  
    const submitFilter = async (filter) => {
      const keys = Object.keys(filter)
      keys.forEach(key => {
        if(filter[key] === '') filter[key] = null
      })
      window.sessionStorage.setItem("allTeacherPayLevelFilter", JSON.stringify(filter))
      getUsers(1, pageSize, null, {...filter, teacherType: "ELICOS"})
    }

    const columns = useMemo(() => [
        {
          Header: "Teacher Name",
          Cell: (props) => <BasicCell content={props.original.name} />
        },
        {
          Header: "State",
          Cell: (props) => <BasicCell content={props.original.stateData} />
        },
        {
          Header: "Date Uploaded",
          Cell: (props) => <BasicCell content={props.original?.pay_level?.uploaded_at ? moment(props.original?.pay_level?.uploaded_at).format('YYYY-MM-DD HH:mm:ss') : ''} />
        },
        {
            Header: "Status",
            Cell: (props) => <BasicCell content={showPayLevelStatus(props.original?.pay_level?.status)} />
          },
        {
          Header: "Reviewed by",
          Cell: (props) => <BasicCell
            content={
              props.original?.pay_level?.reviewed_by?.id
                ? `${props.original?.pay_level?.reviewed_by?.first_name} ${props.original?.pay_level?.reviewed_by?.last_name} ${props.original?.pay_level?.reviewed_by?.state ? `. ${props.original?.pay_level?.reviewed_by?.state}` : ''}. ${moment(props.original?.pay_level?.uploaded_at).format('DD/MM/YYYY')}. ${showPayLevelStatus(props.original?.pay_level?.status)}`
                : ''
            }
          />
        },
        {
          Header: "Upload Details",
          width: 120,
          Cell: (props) => <Link
            className="btn btn-primary btn-block btn-c primary-button-no-margin-hover mt-2"
            onClick={() => {
              window.sessionStorage.setItem("admin-check-teacher", JSON.stringify(props.original));
              history.push("/validatedocuments")
            }}
          >
            More
          </Link>
        },
      ]);
    
      const BasicCell = ({ content }) => (
        <div className="basic-cell-container">
          <div className="basic-cell-child-element">{content}</div>
        </div>
      );

      const getUsers = async (page, limit, keyword, filter = {}) => {
        setLoading(true);
        const filterReq = {
          ["filter[first_name]"]: filter.firstName,
          ["filter[last_name]"]: filter.lastName,
          ["filter[preferred_name]"]: filter.preferredName,
          ["filter[email]"]: filter.email,
          ["filter[state]"]: filter.state,
          ["filter[is_searchable]"]: filter.isSearchable,
          ["filter[is_in_xero]"]: filter.isInXero,
          ["filter[teacher_type]"]: filter.teacherType,
          ["filter[ecec_teacher_level]"]: filter.ececTeacherLevel,
          ["filter[vet_teacher_level]"]: filter.vetTeacherLevel,
        }

        API.allUsersPayLevel(page, limit, keyword, filterReq)
          .then(res => {
            const totalPage = res.data.paginate.total_page
            if (page > totalPage) {
              setCurrentPage(totalPage)
              getUsers(totalPage, limit, keyword, filterReq)
            } else {
              let users = res.data.data.users.filter((t) => !t.deleted_at)
              users.map(user => {
                user.stateData = getTeacherState(user)
                user.name = getTeacherFullName(user)
              })

              setAllUsers(users);
              setPageCount(totalPage)
              setLoading(false);
            }
          })
          .catch(function (err) {
            console.log(err);
            setLoading(false);
          });
      }

      useEffect(() => {
        const previousFilter = window.sessionStorage.getItem("allTeacherPayLevelFilter")
        const filterData = previousFilter ? JSON.parse(previousFilter) : null
      
        if(filterData) {
          getUsers(currentPage, pageSize, '', { ...filterData, teacherType: 'ELICOS' })
        }
        else {
          getUsers(currentPage, pageSize, '', { teacherType: 'ELICOS' })
        }
      }, [currentPage, pageSize]);

    return (
        <AdminWrapper>
            <SwitchMenuBar isViewAsTeacher />
            <div className="all-availability-table-container">
            <h1 className="text-3xl font-bold text-center">Teachers Pay Level</h1>
            <img className="teacher-rate" style={{width: '50%', height: '50%'}} alt="teacher rate" src={'https://readyteacher-public-images.s3.ap-southeast-2.amazonaws.com/pay-level.png'} />

            <div className="w-100 my-4">
              <BuildFilterTeacher 
                initialFilter={initialFilter} 
                submitFilter={submitFilter}
                // exportFilter={exportFilter} 
                disabled={loading}
                // onExport={onExportTeacher}
                setGlobalFilter={setGlobalFilter}
              />
            </div>
            <ReactTable
              className="-striped -highlight"
              showPagination={false}
              data={allUsers}
              sortable={false}
            //   loading={loading}
              pageSize={pageSize}
              columns={columns}
            />
            </div>
            <div className="d-flex justify-content-center">
            <Pagination
              className="mt-3 mr-5"
              page={currentPage}
              count={pageCount}
              onChange={(e, value) => {
                setCurrentPage(value)
              }}
            />
            <FormDropdown
              value={pageSize}
              onChange={(e) => {
                setPageSize(e.target.value)
              }}
            >
              <option value={5}>5 rows</option>
              <option value={10}>10 rows</option>
              <option value={20}>20 rows</option>
              <option value={50}>50 rows</option>
              <option value={100}>100 rows</option>
            </FormDropdown>
          </div>
        </AdminWrapper>
    );
}

export default TeacherPayLevel;